import {Container} from "../Core/Container";
import {Sprite} from "../Core/Sprite";
import {Anchor} from "../Core/Anchor";
import {TweenParams} from "../Core/Animatable";
import {Callback} from "../Core/Reflection";

export class Overlay extends Container {

    private readonly sprite = this.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.middleCenter));

    constructor() {
        super();

        this.sprite.tint = 0xe8ffdd;
        this.sprite.alpha = 0.6;
        this.visible = false;
        this.interactive = true;
    }

    show(duration: number, params?: TweenParams<Overlay> | Callback) {
        this.visible = true;
        this.alpha = 0;
        this.alphaTo<Overlay>(1, 0.15, params);
    }

    hide(duration: number, params?: TweenParams<Overlay> | Callback) {
        if (typeof params === "function") {
            const cb = params;
            params = {onComplete: cb};
        }
        params = params || {};
        const cb = params.onComplete;
        params.onComplete = () => {
            this.visible = false;
            if (cb) cb();
        }
        this.alphaTo<Overlay>(0, 0.15, params);
    }
}